import styled from 'styled-components';
import '../styles/FadeInFromBottom.css'
import FadeInFromBottom from '../shared/FadeInFromBottom';

const Wrapper = styled.div`
  h2 {
    color: #030000;
    font-size: 11px;
    font-weight: bold;
  }
`;

const TitleSmall = (props) => {
    return (
      <Wrapper>
        {props.title === 'ブランドストーリー' ? (
          <h2>／　{props.title}</h2>
        ) : (
          <FadeInFromBottom>
            <h2>／　{props.title}</h2>
          </FadeInFromBottom>
        )}
      </Wrapper>
    );
  };
  
export default TitleSmall;
  